import { createSelector } from 'reselect';
import {
  data2 as data2Selector,
  data as dataSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import { OVERVIEW } from './AccountsStepViews';

export const viewIdSelector = createSelector(
  data2Selector,
  data2 => data2(`${BACKEND_KEY}.accountViewId`) || OVERVIEW,
);

export const accountsSelector = createSelector(dataSelector, data => data(`${BACKEND_KEY}`) || []);

export const visibleAccountsSelector = createSelector(accountsSelector, accounts =>
  accounts.filter(({ IsDeleted }) => !IsDeleted));
